module.exports = __webpack_public_path__ + "img/elecciones20212.5a993551.jpg";